/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartsContainer_user$ref: FragmentReference;
declare export opaque type HeartsContainer_user$fragmentType: HeartsContainer_user$ref;
export type HeartsContainer_user = {|
  +vcCurrent: ?number,
  +tabsToday: ?number,
  +$refType: HeartsContainer_user$ref,
|};
export type HeartsContainer_user$data = HeartsContainer_user;
export type HeartsContainer_user$key = {
  +$data?: HeartsContainer_user$data,
  +$fragmentRefs: HeartsContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HeartsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcCurrent",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabsToday",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '64adb5c4e38e402b97941766dd6a5d0c';
module.exports = node;
